










































import Vue from 'vue';
import SiteForm from './components/SiteForm.vue'
import { getSites, deleteSites } from '@/modules/site/site.service';
import { UserRoles } from '../../modules/auth/auth.model';

export default Vue.extend({
  data() {
    return {
      search: '',
      expanded: [],
      msgSuccess: '',
      msgError: '',
      selectedLines: [],

      tableHeaders: [
        {
          text: 'Nom',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Adresse', value: 'address' },
        { text: 'Code postal', value: 'postalCode' },
        { text: 'Ville', value: 'city' },
        { text: 'Pays', value:'country' },
        { text: 'Actions', value: 'actions' }
        
      ],
      siteList: [] as any[],
      isUser: false,
      isSiteManager: false,
      isAdmin: false
    }
  },
  components: {
    SiteForm
  },
  mounted() {
    this.getSitesList();
    const role = localStorage.getItem('user-role');
    if (role === UserRoles.SITEMNGR.key){
      this.isSiteManager = true;
    }else if (role === UserRoles.ADMIN.key){
      this.isAdmin = true;
    }else if (role === UserRoles.USER.key){
      this.isUser = true;
    }
  },
  methods: {
    getSitesList(){
      getSites().then(res=>{
        if (res.data){
        this.siteList = res.data;
        }else if (res.error){
        this.msgError = 'Erreur dans la recupération des sites.'
        }
      });
    },
    deleteSelectedSites(){
      this.msgSuccess = '';
      this.msgError= '';
      deleteSites(this.selectedLines).then(res=>{
        if(res.data){
          if(res.data.successData.length > 0){
            this.msgSuccess = res.data.successData.length+' sites ont été supprimés.';
          }
        }
        if(res.error){
          if(res.error.errorData.length > 0){
            this.msgError = res.error.errorData.length+' sites en erreur n\'ont pas été supprimés. Vérifier qu\'il n\'y a pas de lien avec des groupes.';
          }
        }
        this.selectedLines = [];
        this.getSitesList();
      });
    }
  }
})
